export default __webpack_public_path__ + "static/media/img-spa.deb53909.png";